import React, { useState, useEffect } from "react";

// Import JSX-based components
import Base1 from "assets/avatars/ortivis/frame_1/base_1";
import Base2 from "assets/avatars/ortivis/frame_2/base_2";
import Base3 from "assets/avatars/ortivis/frame_3/base_3";
import Base4 from "assets/avatars/ortivis/frame_4/base_4";

import CheveuxM1 from "assets/avatars/ortivis/frame_1/cheveux_m_1";
import CheveuxM2 from "assets/avatars/ortivis/frame_2/cheveux_m_2";
import CheveuxM3 from "assets/avatars/ortivis/frame_3/cheveux_m_3";
import CheveuxM4 from "assets/avatars/ortivis/frame_4/cheveux_m_4";

import CheveuxF1 from "assets/avatars/ortivis/frame_1/cheveux_f_1";
import CheveuxF2 from "assets/avatars/ortivis/frame_2/cheveux_f_2";
import CheveuxF3 from "assets/avatars/ortivis/frame_3/cheveux_f_3";
import CheveuxF4 from "assets/avatars/ortivis/frame_4/cheveux_f_4";

import Pantalon1 from "assets/avatars/ortivis/frame_1/pantalon_1";
import Pantalon2 from "assets/avatars/ortivis/frame_2/pantalon_2";
import Pantalon3 from "assets/avatars/ortivis/frame_3/pantalon_3";
import Pantalon4 from "assets/avatars/ortivis/frame_4/pantalon_4";

import TShirt1 from "assets/avatars/ortivis/frame_1/t_shirt_1";
import TShirt2 from "assets/avatars/ortivis/frame_2/t_shirt_2";
import TShirt3 from "assets/avatars/ortivis/frame_3/t_shirt_3";
import TShirt4 from "assets/avatars/ortivis/frame_4/t_shirt_4";

import Visage1 from "assets/avatars/ortivis/frame_1/visage_1";
import Visage2 from "assets/avatars/ortivis/frame_2/visage_2";
import Visage3 from "assets/avatars/ortivis/frame_3/visage_3";
import Visage4 from "assets/avatars/ortivis/frame_4/visage_4";

import Chaussures from "assets/avatars/ortivis/chaussures";

const OrtivisAvatarPreview = ({ avatar }) => {
	const [frameIndex, setFrameIndex] = useState(0);

	// Define animation frames
	const frames = [
		{
			base: Base1,
			face: Visage1,
			trousers: Pantalon1,
			t_shirt: TShirt1,
			hair: avatar?.hair_shape === "cheveux_m" ? CheveuxM1 : CheveuxF1,
		},
		{
			base: Base2,
			face: Visage2,
			trousers: Pantalon2,
			t_shirt: TShirt2,
			hair: avatar?.hair_shape === "cheveux_m" ? CheveuxM2 : CheveuxF2,
		},
		{
			base: Base3,
			face: Visage3,
			trousers: Pantalon3,
			t_shirt: TShirt3,
			hair: avatar?.hair_shape === "cheveux_m" ? CheveuxM3 : CheveuxF3,
		},
		{
			base: Base4,
			face: Visage4,
			trousers: Pantalon4,
			t_shirt: TShirt4,
			hair: avatar?.hair_shape === "cheveux_m" ? CheveuxM4 : CheveuxF4,
		},
	];

	// Change animation frame every 300ms
	useEffect(() => {
		const interval = setInterval(() => {
			setFrameIndex((prev) => (prev + 1) % frames.length);
		}, 300);
		return () => clearInterval(interval);
	}, []);

	if (!avatar) return;

	const CurrentBase = frames[frameIndex].base;
	const CurrentCheveux = frames[frameIndex].hair;
	const CurrentPantalon = frames[frameIndex].trousers;
	const CurrentTShirt = frames[frameIndex].t_shirt;
	const CurrentVisage = frames[frameIndex].face;

	return (
		<div className="relative w-[50px] h-[100px] flex items-center justify-center">
			<svg height={100} viewBox="0 0 200 400">
				{/* Base with skin color */}
				<CurrentBase fillColor={avatar.skin_color} />

				{/* Visage */}
				<CurrentVisage />

				{/* Cheveux (Male or Female) */}
				<CurrentCheveux fillColor={avatar.hair_color} />

				{/* Pantalon */}
				<CurrentPantalon fillColor={avatar.trousers_color} />

				{/* T-Shirt */}
				<CurrentTShirt fillColor={avatar.t_shirt_color} />

				{/* Chaussures (always black) */}
				<Chaussures />
			</svg>
		</div>
	);
};

export default OrtivisAvatarPreview;
